import { Icon, symbolName } from './Icon'

export type StopRecordingIconProps = {
  size?: number
  color?: string
}

export function StopRecordingIcon({
  size = 13,
  color = '#050505',
}: StopRecordingIconProps) {
  return (
    <Icon
      name={symbolName('stop.circle.fill', 'stop_circle')}
      size={size}
      color={color}
    />
  )
}
